<template>
  <v-layout class="d-flex justify-center align-center add4"

            v-if="!$store.state.isPremiumUser"
  >
    <iframe
      v-if="rootPath == 'https://alpaca-connect.com'"
      style="width: 120px; height: 204px; border-bottom: 1px solid #ddd;"
      marginwidth="0"
      marginheight="0"
      scrolling="no"
      frameborder="0"
      :src="`//rcm-fe.amazon-adsystem.com/e/cm?lt1=_blank&bc1=000000&IS2=1&bg1=FFFFFF&fc1=000000&lc1=0000FF&t=alpacaconnect-22&language=ja_JP&o=9&p=8&l=as4&m=amazon&f=ifr&ref=as_ss_li_til&${adSrc}`"
    ></iframe>

    <v-sheet
      color="#eee"
      v-else
      height="120"
      width="204"
      class="d-flex justify-center align-center"
    >
      add04
    </v-sheet>
  </v-layout>
</template>

<script>
export default {
  name: "Add04",

  /*

    */
  props: {},
  data() {
    return {
      adSrcs: [
        // "asins=4799104985&linkId=bcbe4a9f8d7a43d484562771334334cd",
        // "asins=4845913100&linkId=1ce990b565b3a476b2f8fc1a9b79abcf",
        // "asins=4871100952&linkId=ea7b6368d1e2d2c523082b8294109dc6",
        // "asins=4576210475&linkId=2532fdf8dda116737f39480b6f34fafb",
        // "asins=404896822X&linkId=73c3a4590e35785453faecc38718cdeb",
        // "asins=4046024321&linkId=86130275f5e2b303f7bbb49bac890b59",
        // "asins=4046044306&linkId=167ca00997714841ba22fa6665eaaf0e",
        // "asins=4046051361&linkId=d7482c4d15f919953ad106d5530d0410",
        // "asins=4802202016&linkId=934da6cbdb28ee13ca288f7be0dc2774",
        // "asins=B01DJ6KDUS&linkId=412c2493ee9d89da006721e8adfd4a63",
        // "asins=4418172009&linkId=6810a598efa1c89000b96dd4d4377da4",
        // "asins=4775319035&linkId=5db976b0b35107a8a4f4da249a5a481d",
        // "asins=B08XMN3LTQ&linkId=c50057d245bfa072d14eae447782d5ac",
        // "asins=4478108536&linkId=3350bc2df09a19fd18355df802da47a0",
        // "asins=4798063339&linkId=81ca32244445a92a242b231a2a0e7500",
        // "asins=4775317911&linkId=94e17fea0c114599dabf19ee7e04afd4",
        // "asins=4801400604&linkId=1f5cb0d02af7da5ad6029a7ac7d4cc1b",
        // "asins=B084GHT1TB&linkId=dbb69809a12f3d471cff6e12833c9d2e",
        // "asins=4866213035&linkId=a96dd3a0433be6ff9391ef39ba6d7ea0",
        // "asins=4022611561&linkId=b71ef76bc8de4a88ce545f61006ee315",
        // "asins=B075GNQ6WT&linkId=28c398673b9de48aad7b34e6fc7b6307",
        // "asins=4058000155&linkId=f52d18169d864d2d3034a213b1b3d3a7",
        // "asins=4862463606&linkId=9b8fe04af2efe64625063b50d1c8351a",
        // "asins=4862461530&linkId=4739fdb0c1414dfb6cc946b99bc5c6f9",
        // "asins=448043741X&linkId=ba0fbda5ce35c70c3beb334f87fed7c3",
        // "asins=4385162255&linkId=9b135ed30ec7c02fc1a5b808e5876038",
        // "asins=4336066744&linkId=4d544e618aac79de439f7a3190857ab3",
        // "asins=B00BXW2K8Y&linkId=908c09aab52cdde7723596f86fbc777b",
        // "asins=4480038094&linkId=6f5aea517970d032b1539dbf1a0f8e0c",
        // "asins=4480039287&linkId=d9a986cb3d0e58523db4b88c0cfae6a1",
        // "asins=4775315021&linkId=4583d716ca5c08064922bfd0ca10ce23",
        // "asins=B07M5DGRDY&linkId=3782bca4f1f0a533bd95300320d3fb9e",
        // "asins=B01LVYVJJP&linkId=d4dcd6539a8df65cba0c58e4229d6f21",
        // "asins=B00U28PSAC&linkId=33ed621faa74e30a269bfa33f0fc3018",
        // "asins=4758032556&linkId=62d704a6f6b9c175906a5dba8cae8fce",
        // "asins=4861527597&linkId=89b82cc1b329dc2ef56f4ae90ec26703",
        "asins=B0BKZQHL9T&linkId=5795492cd14d8b918b1263376f6bfc0c",
        "asins=4864727694&linkId=8657a85e8518faad504a404a5631da8e",
        "asins=4041131669&linkId=a58e28472983cb798fd7ed97907ae1d4",
        "asins=4040745361&linkId=b9ffb561cb6756718f4a89955e62fdcd",
        "asins=B08W9RTHL4&linkId=b12594ce069950f28820c757d529c5e2",
        "asins=B0BNQ3Y325&linkId=2d752d8fb3d824c19d2e909f8431de2e",
        "asins=4775315021&linkId=0a7ac7f42caa38fdb9abc213a648c09b",
        "asins=4863132042&linkId=9e81291cb8bc554e9f711ceeeabf43b3",
        "asins=B0BPLPDN2K&linkId=5adb2c028bb2df9a6e961b8fd7380c8c",
        "asins=4058015381&linkId=75d7ac96d08684033cff688eeb4213b3",
        "asins=B09FKWBR4P&linkId=00b9428d681c289c0c385213cbff5dc8",
        "asins=4910935401&linkId=1a98d6168828a434b4d0f42dd0f6c292",
        "asins=491093541X&linkId=f4675feeaabde8440e6451ceb88a7110",
        "asins=B0B4T1STT1&linkId=3d8241f26723833e0e18e8f5e82a9a91",
        "asins=B0BSNK1J5N&linkId=eb1502e23c47842c4478649ef3de4f87",
        "asins=475812115X&linkId=7f144250fe0caf558901d847145c93b2",
        "asins=475625358X&linkId=d23f12c507ddb55e30b152ad16170078",
        "asins=4528010038&linkId=0d1b7e7d816b8c891b0030776df42434",
        "asins=4863132905&linkId=7aa740a4e6a7337e59640bdd7579265d",
        "asins=4887217102&linkId=72cc0bb8ddb94931621f8183990fd955",
        "asins=4582766935&linkId=df7b78b03c2377e57b93935a37163fe5",
        "asins=B08R713PLH&linkId=6bd73111be600f27eef53507ad1199aa",
        "asins=4309227813&linkId=d1d2df64a466603e83f06634e22fec4e",
        "asins=430941804X&linkId=3f7f81a6850804c8de40f2593c9f538d",
        "asins=B09V291GT9&linkId=9238810ddabaf27771fc05e04261842c",
        "asins=4041131669&linkId=aac3bbdc9fd11afb465f589b08cd00ff",
        "asins=B00DM4ZH3Q&linkId=dece98377eff6f7740d4a558fbf2edef",
        "asins=4151200533&linkId=bc0da1a13d98f2b5b5c78f7c5dda7ee1",
        "asins=4062768534&linkId=a8da4c0cce08a66b39ebd80356ba3f1c",
        "asins=4041010152&linkId=92dd43bc5246667c70ee802ae7b344ed",
      ],
    };
  },
  computed: {
    adSrc() {
      return this.adSrcs[Math.floor(Math.random() * this.adSrcs.length)];
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "@/sass/import.scss";

.add4 {
  min-height: 240px;
  text-align: center;
  @include media($sm) {
    margin: 0;
  }
}
</style>
